// Import necessary React hooks
import { useState } from "react";
import { useNavigate } from "react-router-dom";
// Import necessary Material-UI components
import {
  Box,
  Button,
  Typography,
  Dialog,
  TextField,
  Grid,
  Container,
  CssBaseline,
} from "@mui/material";
// Import custom validation, functions, hooks
import { LoadingButtonText } from "../../common";
import { handleAddNewERPItemCode } from "../functions";
import { validateNewItemERPCode } from "../validation/validateNewItemERPCode";

/**
 * AddNewItemERPCodeDialog component for editing Item ERP Code dialog
 * @param {Object} props - Component props including modal state, data, and callbacks.
 */
export function AddNewItemERPCodeDialog({
  open,
  setOpen,
  sampleRequestID,
  sampleItemID,
  qualityReportsID,
  setReloadData,
}) {
  // Navigation hook from React Router
  const history = useNavigate();
  // State for managing errors
  const [errors, setErrors] = useState();
  // State for controlling form submission loading state
  const [isSubmitting, setIsSubmitting] = useState(false);
  // Function to close the dialog
  const handleClose = () => {
    setOpen(false);
  };
  // Function to handle form submission
  const handleSubmit = async (event) => {
    event.preventDefault();

    // Extract form data into itemDetails object
    const formData = new FormData(event.currentTarget);

    //Create object for API call
    const sampleDetails = {
      sampleRequestID: sampleRequestID,
      sampleItemID: sampleItemID,
      qualityReportsID: qualityReportsID,
      newItemERPCode: formData.get("newItemERPCode"),
    };
    // Validate item ERP code input
    const { validationErrors, isValid } = validateNewItemERPCode(sampleDetails);
    // Set validation errors if not valid
    !isValid && setErrors(validationErrors);
    // Clear errors if valid
    isValid && setErrors();
    // Send data if valid
    isValid &&
      (await handleAddNewERPItemCode(
        setErrors,
        setIsSubmitting,
        sampleDetails,
        setReloadData,
        history
      ));
  };
  console.log(qualityReportsID, "addItemERPCOde");
  // Log errors to console if they exist
  errors && console.log({ errors });
  return (
    <div>
      {/* Dialog for editing ItemERPCode */}
      <Dialog open={open} onClose={handleClose} {...DialogProps}>
        <Box {...MainBoxProps}>
          <Container {...ContainerProps}>
            {/* Modal title */}
            <Typography component="h2" variant="h6">
              Add New Item Code:
            </Typography>
            <CssBaseline />
            <Box {...FormBoxProps} onSubmit={handleSubmit}>
              {/* Form for adding new ERP Code */}
              <Grid container spacing={2}>
                <Grid item xs={12} sm={12}>
                  <TextField
                    required
                    fullWidth
                    id="newItemERPCode"
                    label="New Item Code"
                    name="newItemERPCode"
                    error={errors && errors.newItemERPCode && true}
                    helperText={
                      errors && errors.newItemERPCode !== ""
                        ? errors.newItemERPCode
                        : ""
                    }
                  />
                </Grid>
              </Grid>
              <Grid item xs={12}>
                <Button {...SaveButtonProps} disabled={isSubmitting}>
                  <LoadingButtonText loading={isSubmitting} text="Save" />
                </Button>
              </Grid>
            </Box>
          </Container>
        </Box>
      </Dialog>
    </div>
  );
}

const DialogProps = {
  style: {
    height: "90%",
  },
  PaperProps: { sx: { borderRadius: "10px", width: "40%" } },
};
const MainBoxProps = {
  sx: {
    flexDirection: "column",
  },
};
const ContainerProps = {
  component: "main",
  maxWidth: "sm",
  sx: {
    marginTop: 6,
    marginBottom: 6,
    flexDirection: "column",
    alignItems: "center",
  },
};
const FormBoxProps = {
  component: "form",
  noValidate: true,
  sx: {
    mt: 5,
  },
};
const SaveButtonProps = {
  type: "submit",
  variant: "contained",
  sx: {
    mt: 3,
    width: "150px",
    float: "right",
    mb: 3,
  },
};
